import { AfterViewInit, Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
  PermissionCheckerService,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { ContactUsBaseComponent } from './contact-us-base.component';

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
})
export class ContactUsComponent extends ContactUsBaseComponent {
  
  contactUsAriaHasPopup: string;

  constructor(
    protected override dialog: MatDialog,
    protected override authorizationService: PermissionCheckerService,
    protected override translationService: PershingTranslationService
  ) {
    super(dialog, authorizationService, translationService);
  }

  ngAfterViewInit(): void {
    this.contactUsAriaHasPopup = 'dialog';
  }

}
